/**
 * The Plugin type name for the Initialization step.
 */
const INITIALIZER = 'Molten.Initializer';

/**
 * The Plugin type name for the Support Component creation mechanism
 */
const SUPPORT_COMPONENTS = 'Molten.SupportComponents';

/**
 * The Plugin type name for the Provider creation mechanism
 */
const PROVIDER = 'Molten.Provider';

/**
 * The Plugin type name for the redux reducer. These reducers are required.
 * Consider a DynamicReducer if possible. 
 */
const REDUX_REDUCER = 'Molten.ReduxReducer';

/**
 * The Plugin type name for the redux middleware 
 */
const REDUX_MIDDLEWARE = 'Molten.ReduxMiddleware';

/**
 * The Plugin type name for callbacks that occur just prior to the react render
 * of the app
 */
const PRERENDER = 'Molten.Prerender';

/**
 * The Plugin type name for the when the user has been authenticated
 */
const LOGGED_IN = 'Molten.LoggedIn';

/**
 * The Plugin type name for callbacks the when the user has logged out
 */
const LOGGED_OUT = 'Molten.LoggedOut';

/**
 * The Plugin type name for callbacks the when the blueprints are being processed
 * and their attribute relationships are being traversed
 */
const BLUEPRINT_RELATIONSHIP_PROCESSOR = 'Molten.blueprintRelationshipProcessor';

/**
 * The Plugin type name for callbacks the when the blueprints have been loaded. These
 * run after the relationship processors
 */
const BLUEPRINTS_PROCESSOR = 'Molten.blueprintsProcessor';

/**
 * The Plugin type name for functions that mutate the UserSettings fallback object when it is installed
 */
const USER_SETTINGS_FALLBACK_MUTATOR = 'Molten.userSettingsFallbackMutator';

// Both export types for backwards compat
export default {
  INITIALIZER,
  SUPPORT_COMPONENTS,
  PROVIDER,
  REDUX_REDUCER,
  REDUX_MIDDLEWARE,
  PRERENDER,
  LOGGED_IN,
  LOGGED_OUT,
  BLUEPRINT_RELATIONSHIP_PROCESSOR,
  BLUEPRINTS_PROCESSOR,
  USER_SETTINGS_FALLBACK_MUTATOR
};